<ng-container>
  <div class="flex items-center justify-between">
    <div
      class="text-xl backdrop-blur-lg text-[#141437] dark:text-white font-medium"
    >
      Side Menu
    </div>

    <app-button
      variant="default"
      (buttonClick)="openPanel()"
      [iconName]="'circlePlus'"
      className="flex items-center justify-center gap-2"
    >
      <span class="font-medium">Add Route</span>
    </app-button>
  </div>

  <div class="card-bg rounded-2xl p-6 mt-4 z-[99] relative">
    <div class="flex flex-col lg:flex-row gap-4">
      <!-- Product  -->
      <div class="flex-1 relative z-40">
        <label
          class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2"
        >
          Status
        </label>
        <app-dropdown
          [options]="statusOptions"
          [selectedValue]="selectedStatus()"
          selectionMode="single"
          placeholder="Select a status"
          [fullWidth]="true"
          (selectionChange)="onStatusFilter($event)"
          class="w-full relative z-50"
        />
      </div>

      <!-- Ai task  -->
      <div class="flex-1 relative z-30">
        <label
          class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2"
        >
          Sort Order
        </label>
        <app-dropdown
          [options]="orderOptions"
          [selectedValue]="selectedOrder()"
          selectionMode="single"
          placeholder="Select an order"
          [fullWidth]="true"
          (selectionChange)="onOrderFilter($event)"
          class="w-full relative z-50"
        />
      </div>

      <!-- <div class="flex items-end z-10">
        <app-button
          [disabled]="!selectedStatus() && !selectedOrder()"
          variant="secondary"
          (buttonClick)="clearFilters()"
          className="px-4 py-2 text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 border border-slate-300 dark:border-slate-600 hover:border-slate-400 dark:hover:border-slate-500 rounded-xl transition-all duration-200"
        >
          Clear Filters
        </app-button>
      </div> -->
    </div>
  </div>

  @if (!isLoading() && productRoutes().length > 0) {
  <div
    class="card-bg rounded-2xl overflow-hidden relative mt-6 border border-slate-200 dark:border-white/5 shadow-sm"
  >
    <!-- Custom Expandable Table -->
    <div
      class="overflow-x-auto w-[600px] max-w-full min-w-full max-h-[700px] pr-2"
    >
      <table class="w-full gap-2 transition-all">
        <!-- Table Headers -->
        <thead class="bg-slate-100 dark:bg-slate-900 sticky top-0 z-20">
          <tr
            class="bg-slate-50/80 dark:bg-white/[0.03] border-b border-slate-200 dark:border-white/5 backdrop-blur-sm"
          >
            <th
              class="px-6 py-4 text-sm text-left font-medium text-slate-600 dark:text-slate-300 w-[18%] whitespace-nowrap"
            >
              Name
            </th>
            <th
              class="px-6 py-4 text-sm font-medium text-slate-600 dark:text-slate-300 w-[6%] text-center whitespace-nowrap"
            >
              Order
            </th>
            <th
              class="px-6 py-4 text-sm font-medium text-slate-600 dark:text-slate-300 w-[12%] text-center whitespace-nowrap"
            >
              Parent
            </th>
            <th
              class="px-6 py-4 text-sm font-medium text-slate-600 dark:text-slate-300 w-[16%] whitespace-nowrap"
            >
              Path
            </th>
            <th
              class="px-6 py-4 text-sm font-medium text-slate-600 dark:text-slate-300 w-[12%] whitespace-nowrap"
            >
              Component Name
            </th>
            <th
              class="px-6 py-4 text-sm font-medium text-slate-600 dark:text-slate-300 w-[16%] whitespace-nowrap"
            >
              Component Path
            </th>
            <th
              class="px-6 py-4 text-sm font-medium text-slate-600 dark:text-slate-300 w-[5%] text-center whitespace-nowrap"
            >
              Icon
            </th>
            <th
              class="px-6 py-4 text-sm font-medium text-slate-600 dark:text-slate-300 w-[10%] whitespace-nowrap"
            >
              Created At
            </th>
            <th
              class="px-6 py-4 text-sm font-medium text-slate-600 dark:text-slate-300 w-[5%] text-center"
            >
              Action
            </th>
          </tr>
        </thead>

        <!-- Table Body -->
        <tbody class="divide-y divide-slate-100 dark:divide-white/5">
          @for (productData of productRoutes(); track $index) {
          <!-- Spacer Row -->
          <!-- <tr class="h-2 bg-transparent"></tr> -->

          <!-- Product Header Row -->
          <tr
            class="bg-slate-50 dark:bg-white/[0.02] cursor-pointer hover:bg-slate-100 dark:hover:bg-white/[0.05] transition-colors"
            (click)="toggleProduct(productData.product.id)"
          >
            <td colspan="9" class="px-6 py-3">
              <div class="flex items-center gap-2">
                <app-icon
                  [size]="16"
                  [name]="
                    expandedProducts().has(productData.product.id)
                      ? 'chevronDown'
                      : 'chevronRight'
                  "
                  class="text-slate-400 dark:text-slate-500"
                ></app-icon>
                <span
                  class="text-sm font-medium text-slate-800 dark:text-slate-100 uppercase tracking-wider opacity-90"
                >
                  {{ productData?.product?.name }}
                </span>
              </div>
            </td>
          </tr>

          <!-- Routes for this product -->
          @if (productData.routes && productData.routes.length > 0) {
          <tr>
            <td colspan="9" class="p-0 border-0">
              <div
                class="overflow-hidden"
                [@expandCollapse]="
                  expandedProducts().has(productData.product.id)
                    ? 'expanded'
                    : 'collapsed'
                "
              >
                @if (expandedProducts().has(productData.product.id)) {
                <table class="w-full table-fixed">
                  <tbody class="divide-y divide-slate-50 dark:divide-white/5">
                    @for (route of productData.routes || []; track $index) {
                    <!-- Main Route Row -->
                    <tr
                      class="group hover:bg-slate-50 dark:hover:bg-white/[0.02] transition-colors border-b border-slate-50 dark:border-white/5 last:border-0"
                      (click)="toggleRow($safeNavigationMigration(route?.id))"
                    >
                      <td [width]="'18%'" class="px-6 py-4 cursor-pointer">
                        <div class="flex items-center gap-2">
                          <div
                            class="p-1 rounded-md text-slate-400 dark:text-slate-500 group-hover:text-purple-600 dark:group-hover:text-white transition-colors"
                          >
                            @if (route.subMenus && route.subMenus.length > 0) {
                            <app-icon
                              [size]="16"
                              [name]="
                                expandedRows().has(route.id)
                                  ? 'chevronDown'
                                  : 'chevronRight'
                              "
                            ></app-icon>
                            } @else {
                            <span class="w-4 h-4 block"></span>
                            }
                          </div>
                          <span
                            class="font-medium text-slate-700 text-sm dark:text-slate-200"
                            >{{ route.name }}</span
                          >
                        </div>
                      </td>
                      <td [width]="'6%'" class="px-6 py-4 text-center">
                        <span
                          class="inline-flex items-center justify-center px-2 py-0.5 rounded text-xs font-medium bg-slate-100 dark:bg-white/10 text-slate-600 dark:text-slate-300"
                        >
                          {{ route.sortOrder }}
                        </span>
                      </td>
                      <td
                        [width]="'12%'"
                        class="px-6 py-4 text-center text-slate-400 dark:text-slate-500 text-xs"
                      >
                        -
                      </td>
                      <td
                        [width]="'16%'"
                        class="px-6 py-4 text-center break-words"
                      >
                        <span
                          class="text-purple-400 font-mono text-xs bg-purple-900/10 px-2 py-1 rounded"
                        >
                          {{ productData.product.basePath || "" }}/{{
                            route.path
                          }}
                        </span>
                      </td>
                      <td
                        [width]="'12%'"
                        class="px-6 py-4 text-xs text-center break-words text-slate-600 dark:text-slate-400 font-mono"
                      >
                        {{ route.componentName || "--" }}
                      </td>
                      <td
                        [width]="'16%'"
                        class="px-6 py-4 text-xs text-center break-words text-slate-500 dark:text-slate-500 italic"
                      >
                        {{ route.componentPath || "--" }}
                      </td>
                      <td [width]="'5%'" class="px-6 py-4 text-center">
                        @if(route.icon){

                        <app-icon [size]="14" [name]="route.icon"></app-icon>

                        } @else {
                        <span class="text-slate-300 dark:text-slate-600"
                          >-</span
                        >
                        }
                      </td>
                      <td
                        [width]="'10%'"
                        class="px-6 py-4 text-xs text-slate-500 dark:text-slate-400 whitespace-nowrap"
                      >
                        {{ formatDate(route.createdAt) }}
                      </td>
                      <td [width]="'5%'" class="px-6 py-4 text-center">
                        <div
                          class="flex items-center justify-center gap-3 opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                          @if(route?.status == 'ACTIVE'){
                          <button
                            class="p-1.5 rounded-md hover:bg-blue-50 dark:hover:bg-[#1E6AFD]/20 text-slate-400 hover:text-[#1E6AFD] dark:text-slate-500 transition-colors cursor-pointer"
                            (click)="
                              editRoute(
                                route,
                                $event,
                                route.subMenus.length > 0 ? true : false
                              )
                            "
                            title="Edit"
                          >
                            <app-icon [size]="16" name="squarePen"></app-icon>
                          </button>
                          <button
                            class="p-1.5 rounded-md hover:bg-red-50 dark:hover:bg-red-900/20 text-slate-400 hover:text-red-600 dark:text-slate-500 dark:hover:text-red-400 transition-colors cursor-pointer"
                            (click)="deleteRouteConfirm(route, $event)"
                            title="Delete"
                          >
                            <app-icon [size]="16" name="trash"></app-icon>
                          </button>
                          } @else {
                          <button
                            class="p-1.5 rounded-md hover:bg-emerald-50 dark:hover:bg-emerald-900/20 text-slate-400 hover:text-emerald-600 dark:text-slate-500 dark:hover:text-emerald-400 transition-colors cursor-pointer"
                            (click)="toggleStatus(route)"
                            title="Restore"
                          >
                            <app-icon [size]="16" name="undo2"></app-icon>
                          </button>
                          }
                        </div>
                      </td>
                    </tr>

                    <!-- Expanded Submenus -->
                    @if (route.subMenus && route.subMenus.length > 0) {
                    <tr>
                      <td colspan="9" class="p-0 border-0">
                        <div
                          class="overflow-hidden"
                          [@expandCollapse]="
                            expandedRows().has(route.id)
                              ? 'expanded'
                              : 'collapsed'
                          "
                        >
                          @if (expandedRows().has(route.id)) {
                          <table class="w-full table-fixed">
                            <tbody
                              class="divide-y divide-slate-50 dark:divide-white/5"
                            >
                              @for (submenu of route.subMenus; track submenu.id)
                              {
                              <tr
                                class="bg-slate-50/30 dark:bg-white/[0.01] hover:bg-slate-50 dark:hover:bg-white/[0.02] transition-colors border-b border-slate-50 dark:border-white/5 last:border-0 group/sub"
                              >
                                <td
                                  [width]="'18%'"
                                  class="px-6 py-3 pl-12 relative cursor-pointer break-words"
                                >
                                  <!-- (click)="editRoute(submenu, $event)" -->
                                  <!-- Tree Connector -->
                                  <div
                                    class="absolute left-[34px] top-0 bottom-1/2 w-px bg-slate-200 dark:bg-white/10 group-last/sub:bottom-1/2"
                                  ></div>
                                  <div
                                    class="absolute left-[34px] top-1/2 w-4 h-px bg-slate-200 dark:bg-white/10"
                                  ></div>

                                  <div class="flex items-center gap-3 pl-2">
                                    <span
                                      class="text-sm text-slate-600 dark:text-slate-300"
                                      >{{ submenu.name || "--" }}</span
                                    >
                                  </div>
                                </td>
                                <td
                                  [width]="'6%'"
                                  class="px-6 py-4 text-center"
                                >
                                  <span
                                    class="inline-flex items-center justify-center px-2 py-0.5 rounded text-xs font-medium bg-slate-100 dark:bg-white/10 text-slate-600 dark:text-slate-300"
                                  >
                                    {{ submenu.sortOrder }}
                                  </span>
                                </td>
                                <td
                                  [width]="'12%'"
                                  class="px-6 py-3 text-center text-xs text-slate-500 dark:text-slate-400 font-medium"
                                >
                                  <span
                                    class="bg-slate-100/50 dark:bg-white/[0.02] rounded px-2 py-1"
                                  >
                                    {{ route.name }}
                                  </span>
                                </td>
                                <td
                                  [width]="'16%'"
                                  class="px-6 py-3 text-center"
                                >
                                  <span
                                    class="text-slate-500 dark:text-slate-400 font-mono text-[11px] break-words"
                                  >
                                    {{ submenu.path }}
                                  </span>
                                </td>
                                <td
                                  [width]="'12%'"
                                  class="px-6 py-3 text-[11px] text-slate-500 dark:text-slate-400 font-mono break-words"
                                >
                                  {{ submenu.componentName || "--" }}
                                </td>
                                <td
                                  [width]="'16%'"
                                  class="px-6 py-3 text-[11px] text-slate-500 dark:text-slate-500 italic break-words"
                                >
                                  {{ submenu.componentPath || "--" }}
                                </td>
                                <td
                                  [width]="'5%'"
                                  class="px-6 py-3 text-center"
                                >
                                  @if(submenu.icon){
                                  <app-icon
                                    [size]="14"
                                    [name]="submenu.icon"
                                    class="text-slate-400 dark:text-slate-500"
                                  ></app-icon>
                                  } @else { - }
                                </td>
                                <td
                                  [width]="'10%'"
                                  class="px-6 py-3 text-xs text-slate-400 dark:text-slate-500 whitespace-nowrap"
                                >
                                  {{ formatDate(submenu.createdAt) }}
                                </td>
                                <td
                                  [width]="'5%'"
                                  class="px-6 py-3 text-center"
                                >
                                  <div
                                    class="flex items-center justify-center gap-3 opacity-0 group-hover/sub:opacity-100 transition-opacity"
                                  >
                                    @if(submenu?.status == 'ACTIVE'){
                                    <button
                                      class="p-1 rounded hover:bg-cyan-50 dark:hover:bg-[#1E6AFD]/20 text-slate-400 hover:text-[#1E6AFD] dark:text-slate-500 transition-colors cursor-pointer"
                                      (click)="
                                        editRoute(submenu, $event, false)
                                      "
                                      title="Edit"
                                    >
                                      <app-icon
                                        [size]="14"
                                        name="squarePen"
                                      ></app-icon>
                                    </button>
                                    <button
                                      class="p-1 rounded hover:bg-red-50 dark:hover:bg-red-900/20 text-slate-400 hover:text-red-600 dark:text-slate-500 dark:hover:text-red-400 transition-colors cursor-pointer"
                                      (click)="
                                        deleteRouteConfirm(submenu, $event)
                                      "
                                      title="Delete"
                                    >
                                      <app-icon
                                        [size]="14"
                                        name="trash"
                                      ></app-icon>
                                    </button>
                                    } @else {
                                    <button
                                      class="p-1 rounded hover:bg-emerald-50 dark:hover:bg-emerald-900/20 text-slate-400 hover:text-emerald-600 dark:text-slate-500 dark:hover:text-emerald-400 transition-colors cursor-pointer"
                                      (click)="toggleStatus(submenu)"
                                      title="Restore"
                                    >
                                      <app-icon
                                        [size]="14"
                                        name="undo2"
                                      ></app-icon>
                                    </button>
                                    }
                                  </div>
                                </td>
                              </tr>
                              }
                            </tbody>
                          </table>
                          }
                        </div>
                      </td>
                    </tr>
                    } }
                  </tbody>
                </table>
                }
              </div>
            </td>
          </tr>
          } }
        </tbody>
      </table>
    </div>
  </div>
  } @if(isLoading()){

  <div class="relative w-full h-[700px] mt-4">
    <app-individual-toaster></app-individual-toaster>
  </div>

  }

  <!-- Empty State -->
  @if (!isLoading() && productRoutes().length === 0) {
  <div
    class="bg-white/60 dark:bg-slate-800/60 backdrop-blur-lg border border-white/20 dark:border-slate-700/50 rounded-2xl p-12 shadow-lg text-center relative z-10 mt-4"
  >
    <div class="max-w-md mx-auto">
      <div
        class="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-blue-100 to-indigo-100 dark:from-blue-900/30 dark:to-indigo-900/30 rounded-full flex items-center justify-center"
      >
        <app-icon name="inbox" [size]="40" class="text-blue-600 dark:text-blue-400"></app-icon>
      </div>
      <h3 class="text-lg font-medium text-slate-900 dark:text-slate-100 mb-2">
        No Data Found
      </h3>
      <p class="text-slate-600 dark:text-slate-400 mb-6">
        There are no page routes matching your current filters. Try adjusting
        your search criteria or add new page routes.
      </p>
      <app-button
        variant="primary"
        (buttonClick)="openPanel()"
        className="inline-flex items-center gap-2"
      >
        Add Page Route
      </app-button>
    </div>
  </div>
  } @if (panelOpen()) {
  <app-slide-panel
    [outsideClick]="false"
    [open]="panelOpen()"
    [title]="isEdit() ? 'Edit Page Route' : 'Add Page Route'"
    (closed)="closePanel()"
    class="flex-1 text-[#141437] dark:text-white"
    panelClass="min-w-[800px] max-w-[600px] w-fit h-full flex flex-col overflow-hidden card-bg"
  >
    <form
      [formGroup]="form"
      (ngSubmit)="submitForm()"
      class="flex flex-col flex-1 overflow-hidden h-full"
    >
      <section class="flex flex-col gap-4 flex-1 overflow-y-auto pr-1 py-2">
        <div
          class="text-slate-700 dark:text-slate-300 w-full flex flex-col gap-1 relative"
        ></div>

        <div class="grid lg:grid-cols-2 grid-cols-1 gap-4 p-4 rounded-2xl">
          <app-input
            inputClass="border border-slate-200 dark:border-white/10 text-sm"
            variant="custom"
            type="text"
            [placeholder]="'Name'"
            [label]="'Name'"
            [formControlName]="'name'"
            [error]="isInvalid('name', true) ? 'Please enter name' : undefined"
          >
          </app-input>
          <div class="flex flex-col">
            <span class="text-slate-700 dark:text-slate-300 text-sm mb-2"
              >Product</span
            >
            <div class="mt-0">
              <app-dropdown
                [placeholderColor]="'text-[#BFBFC7] dark:text-ink-subtle'"
                size="lg"
                variant="themeBase"
                [options]="productsList()"
                selectionMode="single"
                placeholder="Select a product"
                formControlName="productId"
                (selectionChange)="onProductChange($event)"
              ></app-dropdown>
            </div>
            @if (isInvalid('productId', true)) {
            <span class="text-red-600 dark:text-red-400 text-xs mt-1"
              >Please select product</span
            >
            }
          </div>

          <div class="flex flex-col">
            <span class="text-slate-700 dark:text-slate-300 text-sm mb-2"
              >Parent Route</span
            >

            <div
              class="mt-0"
              [class.opacity-50]="!selectedProduct() || hasChild()"
              [class.pointer-events-none]="!selectedProduct() || hasChild()"
            >
              <app-dropdown
                [placeholderColor]="'text-[#BFBFC7] dark:text-ink-subtle'"
                size="lg"
                variant="themeBase"
                [options]="parentMenuList()"
                selectionMode="single"
                [isCheckUnCheck]="true"
                placeholder="Select parent route"
                [formControlName]="'parentId'"
                (selectionChange)="onParentChange($event)"
              ></app-dropdown>
            </div>
            <!-- @if (isInvalid('parentName', true)) {
            <span class="text-red-500 text-xs mt-1">Please select parent</span>
            } -->
          </div>
          <app-input
            inputClass="border border-slate-200 dark:border-white/10 text-sm"
            variant="custom"
            type="text"
            [placeholder]="'Path'"
            [label]="'Path'"
            [formControlName]="'path'"
            [error]="isInvalid('path', true) ? 'Please enter path' : undefined"
          >
          </app-input>
          <app-input
            inputClass="border border-slate-200 dark:border-white/10 text-sm"
            variant="custom"
            type="text"
            [placeholder]="'Icon'"
            [label]="'Icon'"
            [formControlName]="'icon'"
            [error]="isInvalid('icon', true) ? 'Please enter icon' : undefined"
          >
          </app-input>
          <app-input
            inputClass="border border-slate-200 dark:border-white/10 text-sm"
            variant="custom"
            type="number"
            [min]="0"
            [placeholder]="'Order'"
            [label]="'Order'"
            [formControlName]="'order'"
            [error]="
              isInvalid('order', true) ? 'Please enter order' : undefined
            "
          >
          </app-input>
          <app-input            
            inputClass="border border-slate-200 dark:border-white/10 text-sm"
            variant="custom"
            type="text"
            [placeholder]="'Component Name'"
            [label]="'Component Name'"
            [formControlName]="'componentName'"
            [error]="
              isInvalid('componentName', true)
                ? 'Please enter component name'
                : undefined
            "
          >
          <!-- remove readonly [readonly]="isEdit() && !selectedParent()" -->
            <!-- [readonly]="isEdit()" -->
          </app-input>
          <app-input            
            inputClass="border border-slate-200 dark:border-white/10 text-sm"
            variant="custom"
            type="text"
            [placeholder]="'Component Path'"
            [label]="'Component Path'"
            [formControlName]="'componentPath'"
            [error]="
              isInvalid('componentPath', true)
                ? 'Please enter component path'
                : undefined
            "
          >
          <!-- remove readonly [readonly]="isEdit() && !selectedParent()" -->
            <!-- [readonly]="isEdit()" -->
          </app-input>

          <div class="flex flex-col">
            <span class="text-slate-700 dark:text-slate-300 text-sm mb-2"
              >Module</span
            >
            <div
              class="mt-0"
            >
            <!-- remove disabled classes [class.opacity-50]="isEdit() && !selectedParent()" [class.pointer-events-none]="isEdit() && !selectedParent()" -->
              <!-- [class.opacity-50]="isEdit()"
              [class.pointer-events-none]="isEdit()" -->
              <app-dropdown
                [placeholderColor]="'text-[#BFBFC7] dark:text-ink-subtle'"
                size="lg"
                variant="themeBase"
                [options]="moduleList()"
                selectionMode="single"
                placeholder="Select module"
                [formControlName]="'moduleId'"
                (selectionChange)="onModuleChange($event)"
                [isCheckUnCheck]="true"
              ></app-dropdown>
            </div>
            @if (isInvalid('moduleId', true)) {
            <span class="text-red-500 text-xs mt-1">Please select module</span>
            }
          </div>

          <div class="flex items-center justify-evenly gap-2">
            <div class="flex flex-col items-center gap-2">
              <span
                class="flex items-center gap-2 text-slate-700 dark:text-slate-300 text-sm"
                >Only Path

                <!-- <app-tooltip
                  position="left"
                  content="If enabled, the route will only be accessible via its path."
                  variant="info"
                  width="450px"
                  className="!z-[99999] !whitespace-normal !break-words"
                >
                  <app-icon
                    name="circleAlert"
                    [size]="14"
                    class="text-slate-500 dark:text-slate-400 cursor-help"
                  ></app-icon>
                </app-tooltip> -->
              </span>
              <mat-slide-toggle
                formControlName="onlyPath"
                class="small-toggle"
                (change)="toggleTimeMode($event)"
              >
              </mat-slide-toggle>
            </div>
            <div class="flex flex-col items-center gap-2">
              <span
                class="flex items-center gap-2 text-slate-700 dark:text-slate-300 text-sm"
                >Public
                <!-- <app-tooltip
                  position="left"
                  content="If enabled, the route will be accessible to all users without authentication."
                  variant="info"
                  width="450px"
                  className="!z-[99999] !whitespace-normal !break-words"
                >
                  <app-icon
                    name="circleAlert"
                    [size]="14"
                    class="text-slate-500 dark:text-slate-400 cursor-help"
                  ></app-icon>
                </app-tooltip> -->
              </span>
              <mat-slide-toggle
                formControlName="isPublic"
                class="small-toggle"
                (change)="toggleTimeMode($event)"
              >
              </mat-slide-toggle>
            </div>
          </div>

          @if(selectedModule() === 'addNewModule') {
          <app-input
            inputClass="border border-slate-200 dark:border-white/10 text-sm"
            variant="custom"
            type="text"
            [placeholder]="'Module Name'"
            [label]="'Module Name'"
            [formControlName]="'moduleName'"
            [error]="
              isInvalid('moduleName', true)
                ? 'Please enter module name'
                : undefined
            "
          >
          </app-input>
          }
        </div>
      </section>

      @if(errorMessage()) {
      <app-alert
        [message]="errorMessage()"
        [duration]="5000"
        [type]="'error'"
        [closable]="true"
        [showProgress]="true"
        (close)="errorMessage.set('')"
      ></app-alert>
      } @if(successMessage()) {
      <app-alert
        [message]="successMessage()"
        [duration]="3000"
        [type]="'success'"
        [closable]="true"
        [showProgress]="true"
        (close)="successMessage.set('')"
      ></app-alert>
      }

      <div
        class="grid grid-cols-2 gap-3 p-4 sticky bottom-0 border-t border-[#EAEAEA] dark:border-line mt-3"
      >
        <app-button
          type="button"
          variant="defaultBorder"
          (buttonClick)="clearForm()"
          className="w-full"
          >Cancel</app-button
        >
        <app-button type="submit" variant="default" className="w-full">
          {{ isEdit() ? "Update" : "Submit" }}
        </app-button>
      </div>
    </form>
  </app-slide-panel>
  }

  <!-- Audit Logs -->
  <div class="mt-6 pb-12">
    <app-audit-log-panel [entityType]="auditEntityTypes" [showProductFilter]="true" title="Page Routes Audit Trails">
    </app-audit-log-panel>
  </div>
</ng-container>
